import { useItemSet } from '@exam-management/common/item-set-provider';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { FormRichTextEditor } from '@exam-management/rich-text-editor';
import { ReadonlyField } from '@shared/components';
import { useHasPermission } from '@shared/permissions';

import { BaseItemSetParagraphSection, ItemSetContentPreviewer } from '../../components';
import { EDITABLE_ITEM_SET_QUESTION_DETAILS_STATUSES } from '../../constants';
import { useUploadImageForQuestion } from '../../hooks';

export default function ItemSetParagraphSection() {
  const { itemSet } = useItemSet();

  const { handleUpload, loading: isLoading } = useUploadImageForQuestion({
    questionGroupId: itemSet.id ? itemSet.id : undefined,
  });

  const hasUpdatePermission = useHasPermission(APP_PERMISSIONS.QBANK.QUESTION.UPDATE);

  const isEditableByStatus = EDITABLE_ITEM_SET_QUESTION_DETAILS_STATUSES.includes(itemSet.status);
  const isEditable = isEditableByStatus && hasUpdatePermission;

  return (
    <BaseItemSetParagraphSection>
      {isEditable ? (
        <FormRichTextEditor
          placeholder='กรอกบทความที่นี่'
          name='details.paragraph'
          rows={2}
          onImageUpload={handleUpload}
          loading={isLoading}
        />
      ) : (
        <ReadonlyField
          content={
            <ItemSetContentPreviewer
              content={itemSet.metadata?.paragraph ?? ''}
              itemSetId={itemSet.id}
            />
          }
        />
      )}
    </BaseItemSetParagraphSection>
  );
}
